export function isEditMode() {
    return document.body.getAttribute("data-editmode") === "true";
}

export function validate() {
    if (!this.$refs.checkOnChange) {
        return;
    }

    let errors = 0;

    this.$refs.inputs.forEach((input) => {
        const row = input.closest(".form-row");

        if (!row) return;

        if (input.validity.valid) {
            row.classList.remove("has-error");
        } else {
            row.classList.add("has-error");
            if (row.querySelector(".error-message")) {
                row.querySelector(".error-message").innerHTML =
                    input.validationMessage;
            }
            errors++;
        }
    });

    return errors <= 0;
}

export function submit(e) {
    e.preventDefault();

    if (this.$refs.form.classList.contains("is-loading")) {
        return;
    }

    this.$refs.form.classList.add("is-loading");

    this.$refs.checkOnChange = true;

    if (validate.bind(this)) {
        this.$refs.form.submit();
    }else{
        this.$refs.form.classList.remove("is-loading");
    }
}
